import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import { restoreViewState } from 'shared/actions/view';
import {
  overlayOpenStartMenu,
  overlayOpenComposeEditor,
  overlayClose,

  startMenuDisplayLogin,
  startMenuDisplaySignup,
  startMenuDisplayRecover,
  startMenuIsSubmitting,

  overlayOpenEditorDraftNew,  // XXX: Temp
  composeEditorDraftNew,

  newNotification,

  setNavbarVisibility,
  setFooterVisibility,
} from 'shared/actions/view/web';

import {
  OVERLAY_TYPE_START_MENU,
  OVERLAY_TYPE_COMPOSE_EDITOR,
  OVERLAY_DISPLAY_ATTR,
  START_MENU_DISPLAY_CONTEXT_LOGIN,
  START_MENU_DISPLAY_CONTEXT_SIGNUP,
  START_MENU_DISPLAY_CONTEXT_RECOVER,
} from 'shared/constants/web';


const {
  SUSPEND_NAV_OUT,
  SUSPEND_EXIT_WITH_SPINNER,
} = OVERLAY_DISPLAY_ATTR;



const overlayInitialState = {
  isActive: false,
  displayContext: null,
  displayAttrs: [],
  startMenu: {
    displayContext: null,  // XXX: Prob not needed, instead prefer a local state
  },
  composeEditor: {
    displayContext: null,  // moduleId for content
  },
};

// Under top level key 'view'.
const initialState = fromJS({
  navbar: {
    isVisible: true,
    displayAttrs: [],  // XXX: Not used..
  },

  overlay: overlayInitialState,

  // XXX: Using repop for notifications now, remove.
  notification: {
    topLeft: [],
    topMid: [],
    topRight: [],
    bottomLeft: [],
    bottomMid: [],
    bottomRight: [],
  },

  footer: {
    isVisible: true,
  },

  kvEtc: {  // Assortment of arbitrary key-value pairs
  },
});


export default handleActions({
  [restoreViewState]: (state, action) => {
    const { rawStateObj } = action.payload;
    if (!rawStateObj) return state;

    return fromJS(rawStateObj);
  },

  [overlayClose]: (state, action) => {
    const overlay = overlayInitialState;
    return state.merge({overlay});
  },

  [overlayOpenStartMenu]: (state, action) => {
    const overlay = {
      isActive: true,
      displayContext: OVERLAY_TYPE_START_MENU,
      displayAttrs: [],
      startMenu: {
        displayContext: START_MENU_DISPLAY_CONTEXT_LOGIN,
      },
      composeEditor: {
        displayContext: null,
      },
    };
    return state.merge({overlay});
  },

  [startMenuDisplayLogin]: (state, action) => {
    return state.updateIn(
      ['overlay', 'startMenu', 'displayContext'],
      val => START_MENU_DISPLAY_CONTEXT_LOGIN
    );
  },

  [startMenuDisplaySignup]: (state, action) => {
    return state.updateIn(
      ['overlay', 'startMenu', 'displayContext'],
      val => START_MENU_DISPLAY_CONTEXT_SIGNUP
    );
  },

  [startMenuDisplayRecover]: (state, action) => {
    return state.updateIn(
      ['overlay', 'startMenu', 'displayContext'],
      val => START_MENU_DISPLAY_CONTEXT_RECOVER
    );
  },

  [startMenuIsSubmitting]: (state, action) => {
    const { isSubmitting } = action.payload;
    const isSubmittingDisplayAttrs = [SUSPEND_NAV_OUT, SUSPEND_EXIT_WITH_SPINNER];

    return (
      state.updateIn(['overlay', 'displayAttrs'], val => {
        if (isSubmitting) {
          return val.concat(isSubmittingDisplayAttrs).toSet().toList();
        } else {
          return val.toSet().subtract(isSubmittingDisplayAttrs).toList();
        }
      })
    );
  },

  [overlayOpenComposeEditor]: (state, action) => {
    const overlay = {
      isActive: true,
      displayContext: OVERLAY_TYPE_COMPOSE_EDITOR,
      displayAttrs: [],
      startMenu: {
        displayContext: null,
      },
      composeEditor: {
        displayContext: null,
      },
    };
    return state.merge({overlay});
  },

  // Open compose editor and draft new in one action.
  // i.e. overlayOpenComposeEditor + composeEditorDraftNew
  [overlayOpenEditorDraftNew]: (state, action) => {
    const { moduleId = null } = action.payload;

    const overlay = {
      isActive: true,
      displayContext: OVERLAY_TYPE_COMPOSE_EDITOR,
      displayAttrs: [],
      startMenu: {
        displayContext: null,
      },
      composeEditor: {
        displayContext: moduleId,
      },
    };
    return state.merge({overlay});
  },

  [composeEditorDraftNew]: (state, action) => {
    const { moduleId = null } = action.payload;
    return state.updateIn(
      ['overlay', 'composeEditor', 'displayContext'],
      val => moduleId
    );
  },

  // XXX: Not used, remove.
  [newNotification]: (state, action) => {
    const { component = null, position = 'topMid' } = action.payload;
    if (!component || !state.hasIn(['notification', position])) {
      return state;
    }

    // Remove "nulled" components (either self or
    // manually dismissed notifications and prepend
    // the new one.
    const notifications = state
      .getIn(['notification', position])
      .filter(val => Boolean(val))
      .unshift(component);

    return state.updateIn(
      ['notification', position],
      val => notifications
    );
  },

  [setNavbarVisibility]: (state, action) => {
    const { isVisible = true } = action.payload;
    return state.updateIn(['navbar', 'isVisible'], val => isVisible);
  },

  [setFooterVisibility]: (state, action) => {
    const { isVisible = true } = action.payload;
    return state.updateIn(['footer', 'isVisible'], val => isVisible);
  },

}, initialState);



// WEBPACK FOOTER //
// ./src/shared/reducers/view/web.js